<template>

    <div class="galaxy::common-canvas-editor-ToolbarTop tw-flex tw-w-full tw-flex-col">

        <div class="card mb-0 tw-pb-3 tw-w-full">
            <div class="card-body tw-pb-0 tw-flex">

                <div>
                    <h4 class="card-title">{{ title }}</h4>
                    <h6 class="card-subtitle tw-mb-0">{{ instruction }}</h6>
                </div>

                <div class="common-canvas-editor-VersionInfo tw-ml-auto tw-text-right tw-flex">

                    <div>
                        <div
                                class="label tw-text-md py-1"
                                :class="versionState == 'live' ? 'label-success' : 'label-warning'">{{ versionState | camelcase }}</div>

                        <h6 class="card-subtitle tw-mb-0 tw-mt-2" v-if="activeCanvasVersion">
                            {{ versionState == 'live' ? 'Gepubliceerd' : 'Live versie gepubliceerd' }}
                            <template v-if="authorName">door <b>{{ authorName }}</b></template>
                            op <b>{{ activeCanvasVersion.activated_at | date('%d-%m-%Y %H:%M') }}</b>
                        </h6>
                    </div>

                    <div v-if="currentLanguageToShow" class="ml-4">
                        <i class="flag-icon" :class="'flag-icon-' + (currentLanguageToShow == 'en' ? 'gb' : currentLanguageToShow)"></i>
                    </div>

                </div>

            </div>
        </div>

    </div>

</template>

<script>

    export default {

        props: {
            activeCanvasVersion: Object,
            canvasVersion: Object,
            versionState: String,
            activeMode: String,
            title: String,
            instruction: String,
            currentLanguageToShow: String,
        },

        computed: {

            authorName()
            {
                return this.canvasVersion.canvas.author?.name;
            },

        },

    }

</script>

<style lang="scss" scoped>

    .galaxy\:\:common-canvas-editor-ToolbarTop {
        border-bottom: 1px solid #ddd !important;

        .card-subtitle.tw-mb-0 {
            margin-bottom: 0 !important;
        }

        .flag-icon {
            font-size: 20px;
            margin-top: 3px;
        }

        .common-canvas-editor-VersionInfo h6 {
            margin: 5px 0 0 0 !important;
        }

    }

</style>